module.exports = __webpack_public_path__ + "static/media/default-gray-profile.c493c718.svg";